import { marketSpecialsToggleFilter } from "@faire/retailer-visitor-shared/features/FaireMarkets/consts";
import { suppliersPath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersPath";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useMemo } from "react";

export const useSuppliersBrandLinkWithMarketsFilter = () => {
  const routingContext = useRetailerRoutingContext();
  return useMemo(
    () =>
      suppliersPath({
        urlIds: [{ id: "All Brands" }],
        queryParams: {
          filters: marketSpecialsToggleFilter,
        },
        routingContext,
      }),
    [routingContext]
  );
};
